import React from "react";
import GetPriceByText from "./GetPriceByText";
import { VariantProps } from ".";
import Standard from "../Price";

const A = ({ selectedProduct, productListingView }: VariantProps) => {
  return (
    <div className="map map-override mapA">
      <Standard
        price={selectedProduct.price.price}
        unitOfMeasure={selectedProduct.unitOfMeasure}
        textSize="small"
      />
      <GetPriceByText
        itemNumber={selectedProduct.itemNumber}
        showContactPhoneNumber
        showLoginLink={
          selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers
        }
        productListingView={productListingView}
      />
    </div>
  );
};

export default A;
